WiseMetering.Collection.IntegrationConfigurations = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.IntegrationConfiguration,
    url: '/integration_configurations'
});
